export class regioneDTO {
    capoluogo: string;
    denominazione: string;
    sigla: string;
    siglaProvinciaCpoluogo: string;
}